import _taggedTemplateLiteral from "/drone/src/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { marginAttributes, propsBlocker } from '../../system';
export var MaterialIconRoot = styled.span.withConfig(propsBlocker)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    font-family: 'Material Icons', serif;\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    box-sizing: border-box;\n    overflow: hidden;\n    flex-shrink: 0;\n    user-select: none;\n    line-height: 1;\n    font-weight: normal;\n    font-style: normal;\n    font-size: ", ";\n    letter-spacing: normal;\n    text-transform: none;\n    white-space: nowrap;\n    word-wrap: normal;\n    direction: ltr;\n    ", "\n"])), function (_ref) {
  var fontSize = _ref.fontSize,
      theme = _ref.theme;
  return theme.typography.pixelToRem(fontSize);
}, marginAttributes);